import Header from "./Header";
import KeyVisual from "../assets/KeyVisual200.jpg";
import styles from "./HeroSection.module.css";
import { DiagonalLabel } from "./DiagonalLabel";

export default function HeroSection() {
  return (
    <section className={styles.heroSection}>
      <img
        src={KeyVisual}
        alt="Hero background"
        className={styles.heroBackground}
      />

      <div className={styles.heroGradientOverlay} />

      <Header />

      <div className={styles.heroTextWrapper}>
        <div className={styles.heroTextBlock}>
          <p>
            NACHHALTIGE LÖSUNGEN AUS STAHL – FÜR LOGISTIK UND PRODUKTION
            <br />
            <br />
            BEHÄLTER, KÄSTEN, GESTELLE, PALETTEN UND INDIVIDUELL ENTWICKELTE
            LADUNGSTRÄGER
            <br />
            <br />
            FÜR MAXIMALE TRAGFÄHIGKEIT, LANGE EINSATZZYKLEN UND EFFIZIENTE
            PROZESSE
          </p>
          <div className={styles.citation}>
            <DiagonalLabel />
          </div>
        </div>
      </div>
    </section>
  );
}
